(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  
  document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    updateContactDetails();
  }, 1000); // Adjust delay if needed
});

function updateContactDetails() {
  const hostname = window.location.hostname;
  const email =
    hostname.endsWith(".us")
      ? "info@usstores.us"
      : hostname.endsWith(".in")
      ? "info@usstores.in"
      : "support@yourdomain.com";

  const phone =
    hostname.endsWith(".us")
      ? "+1 (888) 404-3006"
      : "+91 8999443167‬";

  const phoneHref =
    hostname.endsWith(".us")
      ? "tel:+18884043006"
      : "tel:+918999443167‬";
  

  const selectors = [
    { el: document.querySelector(".phone-number"), setHref: true },
    { el: document.querySelector(".mobile-phone-new"), setHref: true },
    { el: document.querySelector(".footer-phone"), setHref: true },
    { el: document.querySelector(".email-address"),setHref: true, isEmail: true },
    { el: document.querySelector(".mobile-email"), setHref: true, isEmail: true },
    { el: document.querySelector(".Footer-email"), setHref: true, isEmail: true },
  ];

  selectors.forEach(({ el, setHref, isEmail }) => {
    if (el) {
      el.innerHTML = isEmail ? email : phone;
      if (setHref) el.href = isEmail ? `mailto:${email}` : phoneHref ;
    }
  });
}
  

  } catch(e) { console.error(e); }
})();
})();
